const DAY_OF_EMI = 5;

const getEmiFirstDate = (): string => {
  const today = new Date();
  const monthOffset = today.getDate() >= 21 ? 2 : 1;
  const date = new Date(today.getFullYear(), today.getMonth() + monthOffset, DAY_OF_EMI);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

let pendingFundSource: Promise<void> | null = null;

export const waitForFundSource = (): Promise<void> => pendingFundSource || Promise.resolve();

export const assignFundSource = (userData: any, token: string | null): void => {
  if (!token || !userData?.applicationId) return;

  const appId = userData.applicationId;
  const emiFirstDate = getEmiFirstDate();

  const run = async () => {
    try {
      const urlData = JSON.parse(sessionStorage.getItem("eligibility_url_data") || "{}");
      let loanAmount = urlData.courseFees || 0;
      const loanTenure = urlData.loanTenure;
      let productId = urlData.productId || urlData.producId || urlData.product_id || "";

      let summaryCache: any = null;
      const fetchSummary = async () => {
        if (summaryCache) return summaryCache;
        const res = await fetch(
          `${process.env.REACT_APP_DASHBOARD_URL}/summary/user?id=${userData.userId}&applicationId=${appId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        summaryCache = (await res.json())?.data || {};
        return summaryCache;
      };

      if (!loanAmount) {
        const summary = await fetchSummary();
        loanAmount = summary?.loanAmount || summary?.courseFees || 0;
      }

      if (!productId) {
        const instituteName = urlData.instituteName || "";
        let instituteId = "";

        if (instituteName) {
          const instRes = await fetch(
            `${process.env.REACT_APP_DASHBOARD_URL}/institute/info/name?name=${encodeURIComponent(instituteName)}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const instData = await instRes.json();
          instituteId = instData?.data?.[0]?.id || "";
        } else {
          const summary = await fetchSummary();
          instituteId = summary?.instituteId || "";
        }

        const productsRes = await fetch(
          `${process.env.REACT_APP_DASHBOARD_URL}/products/instituteId/active?instituteId=${instituteId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const productsData = await productsRes.json();
        const products: any[] = productsData?.data || [];
        const matched = products.filter((p: any) => p.tenure === loanTenure);
        productId = (matched[0] || products[0])?.productId || "";
      }

      const emiRes = await fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/emi?applicationId=${appId}&productId=${productId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const emiData = await emiRes.json();
      const emi = emiData.data || 4000;

      await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/admin/application/assign-fund-source`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({
          applicationId: appId,
          fundCode: "GBP",
          productId,
          loanAmount,
          emi,
          emiFirstDate,
          dayOfEmi: DAY_OF_EMI,
          rulesStatus: 1,
        }),
      });
    } catch {
      // fire-and-forget: errors are silent
    }
  };

  pendingFundSource = run();
};
